    $(function () {        

        $("#content-navigation li").each(function (index, element) {
            $(element).click(function () {
                $("#content-navigation li").each(function (j, e) {
                    $(e).removeClass("selected");
                });
                $(this).addClass("selected");

            });

            if ($(element).hasClass("selected")) {
                $("#content-navigation li").each(function (j, e) {
                    $(e).removeClass("selected");
                    if (j == index)
                        $(e).addClass("selected");
                });
            }
        });

    });

    $(function() {
        var query = $.deparam.querystring();
        if (query["t"] != null) {
            var topicid = query["t"];
            var litopic = $("li[id= '" + topicid + "']");
            litopic.addClass('selected');
            litopic.parent().parent().addClass('selected');

        }
        else {
            var loc = location.pathname.trim();
            $("[href='" + loc + "']").closest('li').addClass('selected');
            $("[href='" + loc + "']").closest('li').closest('ul').closest('li').addClass('selected');
        }
    });
	    